import { ColumnDef } from "@tanstack/react-table";
import { formatMoney } from "@/core/utils/money";
import type { IcmJob } from "@/icm/types";

const JobTotalCol: ColumnDef<IcmJob, unknown> = {
  accessorKey: "job_total",
  header: "Job Total",
  meta: { size: "120px" },
  cell: ({ getValue }) => {
    const value = getValue() as number | null;
    return value != null ? formatMoney(value.toFixed(2)) : "-";
  },
};

export default JobTotalCol;
